import { useHeaderNavigateStyles } from "./header-navigate.styles";
import { ButtonSignin } from "@/components/button-signin";

export const HeaderNavigateSignin = () => {
  const { styles } = useHeaderNavigateStyles();

  return (
    <div className={styles.signin}>
      <ButtonSignin size="middle" className={styles.signinButton} />
    </div>
  );
};
